export const PaymentFieldTypes = {
  CARD_NUMBER: 'card_number',
  EXPIRATION_DATE: 'expiration_date',
  CVC: 'cvc',
  ZIP_CODE: 'zip_code'
};

export const DEFAULT_CARD_FIELD_STATE = {
  isEmpty: true,
  isFocused: false,
  error: null as null | string
};

export const DEFAULT_CARD_FIELD_STATES = {
  cardNumber: { ...DEFAULT_CARD_FIELD_STATE },
  cvv: { ...DEFAULT_CARD_FIELD_STATE },
  expirationDate: { ...DEFAULT_CARD_FIELD_STATE },
  zip: { ...DEFAULT_CARD_FIELD_STATE }
};
